import { Alert, PageHeader } from "@/components/ui";
import { NETWORK_NAME } from "@/lib/config";
import type { RegistryLookupFailure } from "@/lib/registry/record";

/**
 * What a registry page shows before, and instead of, an answer.
 *
 * Shared by the three lookup pages so the wording cannot drift between them.
 * The whole point of these states is that none of them may be mistaken for
 * "this is not official" — that answer only ever comes from a record whose
 * status is `Unregistered`, rendered by the card.
 */
export function RegistryLoading({ context }: { context: string }) {
  return (
    <div className="page-shell">
      <PageHeader
        context={context}
        title="Memeriksa registry…"
        description={`Membaca catatan dari UtilityRegistry di ${NETWORK_NAME}.`}
      />
      {/* Deliberately not a skeleton shaped like a status card. A grey rectangle
          where a verdict will appear invites the eye to read it as one. */}
      <p className="text-sm text-ink-muted" role="status" aria-live="polite">
        Menunggu jawaban dari rantai. Jangan menyimpulkan apa pun sampai hasilnya muncul.
      </p>
    </div>
  );
}

export function RegistryFailure({
  context,
  failure,
}: {
  context: string;
  failure: RegistryLookupFailure;
}) {
  const unconfigured = failure.kind === "unconfigured";

  return (
    <div className="page-shell">
      <PageHeader
        context={context}
        title={unconfigured ? "Registry belum tersedia" : "Belum bisa diperiksa"}
        description={
          unconfigured
            ? `UtilityRegistry belum dikonfigurasi untuk ${NETWORK_NAME}.`
            : `Catatan registry tidak dapat dibaca dari ${NETWORK_NAME} saat ini.`
        }
      />
      <Alert tone="warn">
        Portal tidak dapat memeriksa status apa pun saat ini. Ini <strong>bukan</strong> berarti
        entitas yang Anda cari tidak resmi — artinya kami belum bisa memeriksanya. Jangan
        menyimpulkan apa pun dari halaman ini.
      </Alert>
      <p className="mt-4 text-sm text-ink-muted">{failure.message}</p>
    </div>
  );
}
